<template>
  <div class="card mb-12" style="min-height: 60vh;">
    <div class="col-md-12">
      <h2 style="margin: 20px 20px 0px;">Full Sync Status</h2>
    </div>

    <div class="mb-12"  style="min-height: 60vh; display: flex; flex-direction: row;">

      <div class="col-md-3" style="border-right: 1px solid #e0e0e0">
        <div class="card-body">

          <div>
            <base-input alternative="" label="Date Range"><br>
              <a-range-picker v-model="dateRange"
                              format="MM-DD-YYYY"
                              :placeholder="['Start Date', 'End Date']"
                              style="width:100%"/>
            </base-input>
          </div>

          <div>
            <h6 class="heading-small text-muted mb-4">Select an Account</h6>
            <a-select showSearch
                      v-model="selectedAccount"
                      placeholder="Select an Account"
                      optionFilterProp="children"
                      style="width: 100%">
              <a-spin v-if="fetchingAccount" slot="notFoundContent" size="small" />
              <a-select-option v-for="account in accounts"
                              :key="account.id"
                              :value="account.id">
                {{account.account_name}}
              </a-select-option>
            </a-select>
          </div>

          <br/>

          <div>
            <h6 class="heading-small text-muted mb-4">Select a Site</h6>
            <a-select showSearch
                      v-model="selectedSite"
                      placeholder="Select a Site"
                      optionFilterProp="children"
                      style="width: 100%">
              <a-spin v-if="fetchingSite" slot="notFoundContent" size="small" />
              <a-select-option v-for="site in sites"
                              :key="site.id"
                              :value="site.id">
                {{site.name}}
              </a-select-option>
            </a-select>
          </div>

          <br/>

          <div>
            <h6 class="heading-small text-muted mb-4">Select Status</h6>
            <a-select showSearch
                      v-model="selectedStatus"
                      placeholder="Select Status"
                      optionFilterProp="children"
                      style="width: 100%">
              <a-spin v-if="fetchingSite" slot="notFoundContent" size="small" />
              <a-select-option v-for="stats in status"
                              :key="stats.value"
                              :value="stats.value">
                {{stats.name}}
              </a-select-option>
            </a-select>
          </div>

          <br/>

          <div>
            <a-button type="primary"
                      size="large"
                      class="btn btn-primary float-right"
                      @click.prevent="getData">
              Filter
            </a-button>
          </div>

        </div>
      </div>

      <div class="col-md-9">
        <div class="card-body">

          <div class="table-responsive" >
            <vuetable v-if="tableURL.length > 0"
                      ref="vuetable"
                      :api-url="tableURL"
                      :http-options="httpOptions"
                      :fields="fields"
                      :show-sort-icons="true"
                      :per-page="10"
                      :css="tableCSS.table"
                      pagination-path=""
                      data-path="data"
                      no-data-template="Empty"
                      @vuetable:load-error="onLoadError"
                      @vuetable:pagination-data="onPaginationData"/>
          </div>

          <div class="card-footer d-flex justify-content-end bg-transparent">
            <div class="pagination ui basic segment grid">
              <vuetable-pagination
                ref="pagination"
                @vuetable-pagination:change-page="onChangePage"
                :css="tableCSS.pagination">
              </vuetable-pagination>
            </div>
          </div>

        </div>
      </div>

    </div>
  </div>
</template>

<script>
import HTTPRequest from '../../controllers/httpRequest.js';
import { mapState } from 'vuex';
import secureStorage from '../../controllers/secureStorage';
import Vuetable from "vuetable-2/src/components/Vuetable";
import VuetablePagination from "vuetable-2/src/components/VuetablePagination";
import { sortAlphabetical } from '../../utilities';
import moment from 'moment';

export default {
  components: {
    Vuetable,
    VuetablePagination
  },
  computed: {
    ...mapState(['endPoint', 'profileId', 'serverType']),
  },

  data() {
    return {
      status: [
        { name: "All", value: "all" },
        { name: "Unprocessed", value: "unprocessed" },
        { name: "Ongoing", value: "ongoing" },
        { name: "Done", value: "done" },
        { name: "Error", value: "error" },
        { name: "Unprocessed and Error", value: "unprocessed_and_error" }
      ],
      fetchingAccount: false,
      fetchingSite: false,
      accounts: [],
      sites: [],
      selectedAccount: null,
      selectedSite: null,
      selectedStatus: 'unprocessed_and_error',
      dateRange: [moment().startOf('day'), moment().endOf('day')],
      fields: [
        {name: "task_id", title: "Task ID"},
        {name: "task_name", title: "Task Name"},
        {name: "account_name", title: "Account Name"},
        {name: "site_name", title: "Site Name"},
        {name : "status", title: "Status"},
        {name : "start", title: "Start"},
        {name : "end", title: "End"},
        {name : "error_msg", title: "Error Msg"},
      ],
      httpOptions: {
        headers: {
          Authorization: 'Bearer ' + secureStorage.getItem("accessToken"), 'Request-Source':"BXI-Web"
        }
      },
      tableURL: '',
      tableCSS: {
        table: {
          tableClass: 'table table-sm table-striped table-bordered table-hovered',
          loadingClass: 'loading'
        },
        pagination: {
          infoClass: 'pull-right',
          wrapperClass: 'vuetable-pagination pull-right',
          activeClass: 'btn-primary btn-sm',
          disabledClass: 'disabled',
          pageClass: 'btn btn-border',
          linkClass: 'btn btn-border',
          icons: {
            first: '',
            prev: '',
            next: '',
            last: '',
          },
        }
      },
      tableData: []
    }
  },

  mounted() {
    this.tableURL = `${this.endPoint}systems/full_sync/log_status`;
    this.getAllAccounts();
  },

  watch: {
    selectedAccount: function() {
      if (this.selectedAccount) {
        this.selectedSite = null;
        this.getSites();
      }
    },
    // selectedSite: function() {
    //   this.setSelectedSiteName();
    // }
  },

  methods: {
    getAllAccounts: async function() {
      // Get all Valid and Active accounts
      let accounts = await HTTPRequest.getRequest(this.endPoint + 'accounts/get_valid_accounts', null, null)
      accounts = sortAlphabetical(accounts, 'account_name')

      this.accounts = accounts || [];
    },

    async getSites() {
      if (!this.selectedAccount) { return; }

      let sites = await HTTPRequest.getRequest(`${this.endPoint}sites/get_sites_with_terminal?account_id=${this.selectedAccount}`, null, null)
      sites = sortAlphabetical(sites, 'name')
      if (sites.length > 0) {
        this.sites = [{id: 0, name: 'All'}, ...sites];
      } else {
        this.sites = [];
      }
    },

    getData: async function() {
      if (!this.selectedAccount) { return }
      this.tableURL = '';

      let tableURL = `${this.endPoint}systems/full_sync/log_status?`;
      tableURL += `account_id=${this.selectedAccount}`;
      tableURL += `&site_id=${this.selectedSite}`;
      tableURL += `&status=${this.selectedStatus}`;
      tableURL += `&from=${this.dateRange[0].format('YYYY-MM-DD')}`;
      tableURL += `&to=${this.dateRange[1].format('YYYY-MM-DD')}`;

      this.tableURL = tableURL
    },

    onLoadError: async function(error) {
      console.log(error)
    },

    onPaginationData: async function(paginationData) {
      this.$refs.pagination.setPaginationData(paginationData);
    },

    onChangePage(page) {
      this.$refs.vuetable.changePage(page);
    },
  }
}
</script>
